import { SectionNames, SocialMediaFields } from "./SectionDataMetaData";

import {
    MetaData,
    APP_TYPE_LIST
} from "./SectionDataMetaData";

import { COUNTRY_CURRENCY_MAP } from "../../../../constants";

export const getImgDetail = (file, fieldName) => {
    const fileName = file ? file.substr(file.lastIndexOf("/") + 1) : "";
    return {
        id: new Date() + fieldName,
        name: fileName,
        displayName: fileName,
        size: 0,
        image: file ?? null,
        upload: false,
    };
}

const getSectionThemes = (serverData, themeColorsObject) => {
    const sectionObject = {};
    for (const propertyData in themeColorsObject) {
        sectionObject[themeColorsObject[propertyData].name] = serverData[propertyData] ?? themeColorsObject[propertyData].defaultValue;
    }
    return sectionObject;
}

export const mapServerToState = (data) => {
    const restaurantData = data ?? {};
    const { themeColors = {} } = restaurantData;
    
    const newState = {
        // Image Section
        [SectionNames.ImagesTab]: {
            printLogo: getImgDetail(restaurantData.printLogo, MetaData.ImagesTab.images.printLogo),
            menuHeaderBg: getImgDetail(themeColors.headerBg, MetaData.ImagesTab.images.menuHeaderBg),
            headerBg: getImgDetail(restaurantData.headerBg, MetaData.ImagesTab.images.headerBg),
            arModelBg: getImgDetail(restaurantData.arModelBg, MetaData.ImagesTab.images.arModelBg),
            bottomMenuIcon: getImgDetail(restaurantData.bottomMenuIcon, MetaData.ImagesTab.bottomMenuIcon),
            menuSectionBgVal: getImgDetail(themeColors.menuSectionBg, MetaData.ImagesTab.images.menuSectionBgVal),
            prevIcon: getImgDetail(themeColors.prevIcon, MetaData.ImagesTab.images.prevIcon),
            nextIcon: getImgDetail(themeColors.nextIcon, MetaData.ImagesTab.images.nextIcon),
            arMenuLogo: getImgDetail(restaurantData.arMenuLogo, MetaData.ImagesTab.images.arMenuLogo),
            shareIconImage: getImgDetail(restaurantData.shareIconImage,MetaData.ImagesTab.images.shareIconImage),

            onlineOrder: restaurantData.onlineOrder,
            tableOrder: restaurantData.tableOrder,
            batchOrderEnabled: restaurantData.tableOrderOptions?.batchOrderEnabled,
            batchDuration: restaurantData.tableOrderOptions?.batchDuration,
            tablePayment: restaurantData.tablePayment,
            // arCategoryGrouping: themeColors.arCategoryGrouping,
            wifiAvailable: restaurantData.wifiAvailable,

            appType: restaurantData.appType ?? APP_TYPE_LIST[0].value
        },
        // AR Page Section
        [SectionNames.ARPageTab]: {
            menuItemNameFont: null, // different file format
            menuItemFontColor: restaurantData.menuItemFontColor,
            menuItemFontBg: restaurantData.menuItemFontBg,
            modalBgColor: restaurantData.modalBgColor,
            menuItemFontFile: restaurantData.menuItemNameFont,
            modalFontColor: restaurantData.modalFontColor,
            userFormDataBg: restaurantData.userFormDataBg,
            userFormDataLabelColor: restaurantData.userFormDataLabelColor,
            userFormDataFontColor: restaurantData.userFormDataFontColor,
            buttonBg: restaurantData.buttonBg,
            buttonTextBg: restaurantData.buttonTextBg,
            arCategoryGrouping: themeColors.arCategoryGrouping,
            arCategoryGroupingPosition: themeColors.arCategoryGroupingPosition,
        },

        // Menu Listing Section
        [SectionNames.MenuListingTab]: getSectionThemes(themeColors, MetaData[SectionNames.MenuListingTab]),
        // Menu Detail Popup
        [SectionNames.MenuDetailsPopupTab]: getSectionThemes(themeColors, MetaData[SectionNames.MenuDetailsPopupTab]),
        // Cart Page
        [SectionNames.CartTab]: getSectionThemes(themeColors, MetaData[SectionNames.CartTab]),
        // Checkout Page
        [SectionNames.CheckoutTab]: getSectionThemes(themeColors, MetaData[SectionNames.CheckoutTab]),
        // Order Success Page
        [SectionNames.OrderSuccessTab]: getSectionThemes(themeColors, MetaData[SectionNames.OrderSuccessTab]),
        // Order History Page
        [SectionNames.OrderHistoryTab]: getSectionThemes(themeColors, MetaData[SectionNames.OrderHistoryTab]),
        // Order Detail Page
        [SectionNames.OrderDetailsTab]: getSectionThemes(themeColors, MetaData[SectionNames.OrderDetailsTab]),
        // Add Address Page
        [SectionNames.AddAddressTab]: getSectionThemes(themeColors, MetaData[SectionNames.AddAddressTab]),
        // Address List Page
        [SectionNames.AddressListTab]: getSectionThemes(themeColors, MetaData[SectionNames.AddressListTab]),
        // Social Media
        [SectionNames.socialMediaTab]: restaurantData.socialMedias ? transformSocialMediaServerToStateData(restaurantData.socialMedias) : [],
        // Category Group
        [SectionNames.categoryGroupsTab]: restaurantData.groupCategory ?? [],
        // Payment Settings
        [SectionNames.PaymentSettingsTab]: {
            stripeDestinationAccountId: restaurantData.paymentSettings?.stripeDestinationAccountId ?
                restaurantData.paymentSettings?.stripeDestinationAccountId :
                restaurantData.paymentInfo?.destinationAccountId ? restaurantData.paymentInfo?.destinationAccountId : null,
            ryftDestinationAccountId: restaurantData.paymentSettings?.ryftDestinationAccountId || null,
            onlineOrderDefaultGateway: restaurantData.paymentSettings?.onlineOrder?.defaultGateway || "stripe",
            onlineOrderApplicationFeePercent: restaurantData.paymentSettings?.onlineOrder?.applicationFeePercent ?
                restaurantData.paymentSettings?.onlineOrder?.applicationFeePercent : 
                restaurantData.paymentInfo?.applicationFeePercent ? restaurantData.paymentInfo?.applicationFeePercent : 0,
            tableOrderDefaultGateway: restaurantData.paymentSettings?.tableOrder?.defaultGateway || "direct",
            tableOrderApplicationFeePercent: restaurantData.paymentSettings?.tableOrder?.applicationFeePercent || 0,
            tableBookingDepositDefaultGateway: restaurantData.paymentSettings?.tableBookingDeposit?.defaultGateway || "stripe",
            tableBookingDepositApplicationFeePercent: restaurantData.paymentSettings?.tableBookingDeposit?.applicationFeePercent || 0,
            giftCardDefaultGateway: restaurantData.paymentSettings?.giftCard?.defaultGateway || "stripe",
            giftCardApplicationFeePercent: restaurantData.paymentSettings?.giftCard?.applicationFeePercent || 0,
        },
        // Multi-Language Settings
        [SectionNames.MultiLanguageTab]: {
            isEnabled: restaurantData.localizationConfig?.isEnabled || false,
            languages: restaurantData.localizationConfig?.languages || [],
        },
        // Table Ordering Menu Layout
        [SectionNames.TableOrderingMenuLayoutTab]: {
            _idMenuLayout: restaurantData._idMenuLayout || "",
        },
    };
    return newState;
}

export const mapStateToServer = (restaurantData, state) => {
    const themeColorsSections = [
        SectionNames.MenuListingTab,
        SectionNames.MenuDetailsPopupTab,
        SectionNames.CartTab,
        SectionNames.CheckoutTab,
        SectionNames.OrderSuccessTab,
        SectionNames.OrderHistoryTab,
        SectionNames.OrderDetailsTab,
        SectionNames.AddAddressTab,
        SectionNames.AddressListTab,
    ];

    const themeColors = {};
    themeColors.headerBg = state[SectionNames.ImagesTab].menuHeaderBg.image ?? null;
    themeColors.nextIcon = state[SectionNames.ImagesTab].nextIcon.image ?? null;
    themeColors.prevIcon = state[SectionNames.ImagesTab].prevIcon.image ?? null;
    themeColors.menuSectionBg = state[SectionNames.ImagesTab].menuSectionBgVal.image ?? null;

    // themeColors.arCategoryGrouping = state[SectionNames.ImagesTab].arCategoryGrouping;
    themeColors.arCategoryGrouping = state[SectionNames.ARPageTab].arCategoryGrouping;
    themeColors.arCategoryGroupingPosition = state[SectionNames.ARPageTab].arCategoryGroupingPosition;

    for (const sectionName of themeColorsSections) {
        for (const property in MetaData[sectionName]) themeColors[MetaData[sectionName][property].name] = state[sectionName][property] ?? null;
    }

    const { currency, country, ...restaurantDataWithoutCurrency } = restaurantData ?? {};
    const resolvedCurrency = currency || COUNTRY_CURRENCY_MAP[country]?.code;

    const newRestaurantData = {
        ...restaurantDataWithoutCurrency,
        ...(country ? { country } : {}),
        ...(resolvedCurrency ? { currency: resolvedCurrency } : {}),
        //Image Section
        printLogo: state[SectionNames.ImagesTab].printLogo.image,
        headerBg: state[SectionNames.ImagesTab].headerBg.image,
        arModelBg: state[SectionNames.ImagesTab].arModelBg.image,
        arMenuLogo: state[SectionNames.ImagesTab].arMenuLogo.image || null,
        shareIconImage: state[SectionNames.ImagesTab]?.shareIconImage?.image || null,
        bottomMenuIcon: state[SectionNames.ImagesTab].bottomMenuIcon.image,

        onlineOrder: state[SectionNames.ImagesTab].onlineOrder,
        tableOrder: state[SectionNames.ImagesTab].tableOrder,
        tableOrderOptions: {
            batchOrderEnabled: state[SectionNames.ImagesTab].batchOrderEnabled,
            batchDuration: state[SectionNames.ImagesTab].batchDuration
        },
        tablePayment: state[SectionNames.ImagesTab].tablePayment,
        wifiAvailable: state[SectionNames.ImagesTab].wifiAvailable,
        appType: state[SectionNames.ImagesTab].appType,

        // AR Page Section
        menuItemFontColor: state[SectionNames.ARPageTab].menuItemFontColor,
        menuItemFontBg: state[SectionNames.ARPageTab].menuItemFontBg ?? null,
        menuItemNameFont: state[SectionNames.ARPageTab].menuItemFontFile ?? null,
        modalBgColor: state[SectionNames.ARPageTab].modalBgColor ?? null,
        modalFontColor: state[SectionNames.ARPageTab].modalFontColor ?? null,
        userFormDataBg: state[SectionNames.ARPageTab].userFormDataBg,
        userFormDataLabelColor: state[SectionNames.ARPageTab].userFormDataLabelColor ?? null,
        userFormDataFontColor: state[SectionNames.ARPageTab].userFormDataFontColor ?? null,
        buttonBg: state[SectionNames.ARPageTab].buttonBg ?? null,
        buttonTextBg: state[SectionNames.ARPageTab].buttonTextBg ?? null,
         // Payment Settings Section
        paymentSettings: {
            stripeDestinationAccountId: state[SectionNames.PaymentSettingsTab]?.stripeDestinationAccountId ?
            state[SectionNames.PaymentSettingsTab]?.stripeDestinationAccountId: null,
            ryftDestinationAccountId: state[SectionNames.PaymentSettingsTab]?.ryftDestinationAccountId || null,
            onlineOrder: {
                defaultGateway: state[SectionNames.PaymentSettingsTab]?.onlineOrderDefaultGateway || "stripe",
                applicationFeePercent: state[SectionNames.PaymentSettingsTab]?.onlineOrderApplicationFeePercent || 0,
            },
            tableOrder: {
                defaultGateway: state[SectionNames.PaymentSettingsTab]?.tableOrderDefaultGateway || "stripe",
                applicationFeePercent: state[SectionNames.PaymentSettingsTab]?.tableOrderApplicationFeePercent || 0,
            },
            tableBookingDeposit: {
                defaultGateway: state[SectionNames.PaymentSettingsTab]?.tableBookingDepositDefaultGateway || "stripe",
                applicationFeePercent: state[SectionNames.PaymentSettingsTab]?.tableBookingDepositApplicationFeePercent || 0,
            },
            giftCard: {
                defaultGateway: state[SectionNames.PaymentSettingsTab]?.giftCardDefaultGateway || "stripe",
                applicationFeePercent: state[SectionNames.PaymentSettingsTab]?.giftCardApplicationFeePercent || 0,
            },
        },
        // Social Media Section
        socialMedias: transformSocialMediaStateToServerData(state[SectionNames.socialMediaTab]) ?? [],
        // Category Group Section
        groupCategory: state[SectionNames.categoryGroupsTab] ?? [],
        // Multi-Language Configuration
        localizationConfig: {
            isEnabled: state[SectionNames.MultiLanguageTab]?.isEnabled || false,
            languages: state[SectionNames.MultiLanguageTab]?.languages || [],
        },
        // Table Ordering Menu Layout
        _idMenuLayout: state[SectionNames.TableOrderingMenuLayoutTab]?._idMenuLayout || null,
        themeColors
    };

    return newRestaurantData;
}

const transformSocialMediaServerToStateData = (serverData) => {
    const returnData = []
    serverData.forEach((item) => {
        const newItem = {
            _id: item._id,
            name: item.name,
            action: item.action ?? "",
            icon: item.icon,
        }
        newItem[SocialMediaFields.url] = item.data ? item.data.url ?? "" : "";
        newItem[SocialMediaFields.iconHeight] = item.data ? item.data.iconHeight ?? "" : "";
        newItem[SocialMediaFields.iconWidth] = item.data ? item.data.iconWidth ?? "" : "";
        returnData.push(newItem);
    })
    return returnData
}

const transformSocialMediaStateToServerData = (stateData) => {
    const returnData = []
    stateData.forEach((item) => {
        const newItem = {
            name: item.name,
            action: item.action,
            icon: item.icon ? typeof item.icon === 'string' ? item.icon : item.icon.image : null,
        }
        if (item._id) newItem._id = item._id;

        if (item[SocialMediaFields.url] || item[SocialMediaFields.iconHeight] || item[SocialMediaFields.iconWidth]) {
            newItem.data = {};
            if (item[SocialMediaFields.url]) newItem.data.url = item[SocialMediaFields.url];
            if (item[SocialMediaFields.iconHeight]) newItem.data.iconHeight = item[SocialMediaFields.iconHeight];
            if (item[SocialMediaFields.iconWidth]) newItem.data.iconWidth = item[SocialMediaFields.iconWidth];
        } else item.data = null;
        returnData.push(newItem);
    })
    return returnData
}